import * as React from "react";
import styles from "./styles.module.css";
import { Button, FormError, FormInput } from "@/components/Shared";
import useSubscribeMailingList from "@/hooks/useSubscribeMailingList";

const MailingList: React.FC = () => {
	const { loading, error, submitted, formik } = useSubscribeMailingList();

	return (
		<div className={styles.mailing_list__container}>
			<div className={styles.title}>
				<h2>Get the latest deals and news sent to your inbox.</h2>
			</div>
			<div className={styles.body}>
				{!submitted ? (
					<>
						<p>
							Receive the latest deals and news for Broadband, Mobile and
							Insurance.
						</p>
						<form onSubmit={formik.handleSubmit}>
							<FormInput
								name="email"
								value={formik.values.email}
								placeholder="Email..."
								handleChange={formik.handleChange}
								isRequired={false}
							/>
							{formik.touched.email && formik.errors.email ? (
								<FormError message="Please enter a valid email." theme="dark" />
							) : null}
							{error && <FormError message={error.message} theme="dark" />}
							<Button
								name="subscribe"
								type="submit"
								title="Subscribe"
								isLoading={loading}
							/>
						</form>
					</>
				) : (
					<p>Thank you for signing up to our mailing list.</p>
				)}
			</div>
		</div>
	);
};

export default MailingList;
